import React, { useCallback } from 'react';
import { observer } from 'mobx-react';
import Modal from 'simple-react-modal';
import dayjs from 'dayjs';
import classnames from 'classnames';

import { CALENDAR_DISPLAY, CALENDAR_DISPLAY_2025 } from '../../constants/modals';
import CALENDAR_PROMO_IMAGE from '../../assets/2023-calendar-promo/2026-calendar-promo-popup-960x540.jpg';
import CALENDAR_PROMO_IMAGE_MOBILE from '../../assets/2023-calendar-promo/2026-calendar-promo-popup-square.jpg';
import ModalStore from '../../store/ModalStore';

import styles from './css/CalendarPromoModal.module.css';
import { dismissModal } from './services';

const ALT_TEXT =
  '12 months of sizzling-hot poses of your favorite naked newscasters, making every day of the year a thing of beauty! Order yours - and extras, because they make perfect Christmas presents!';
const PRODUCT_LINK =
  'https://shop.nakednews.com/index.php/product/its-the-hottest-calendar-for-2026-12-x-12/?utm_source=CALENDAR_POPUP';

const CalendarPromoModal = (props) => {
  const { showCalendarModal, user } = props;
  const { setShouldShowCalendarModal } = ModalStore;

  const handleDismissForever = (e) => {
    e.preventDefault();
    if (user.authenticated) {
      dismissModal({
        visible: false,
        count: 1,
        modalType: CALENDAR_DISPLAY,
      });
    } else {
      const tenYears = dayjs()
        .add(10, 'years')
        .toDate();
      setCookie(tenYears);
    }
    setShouldShowCalendarModal(false);
  };

  const handleClose = () => {
    if (user.authenticated) {
      dismissModal({
        visible: true,
        count: 1,
        modalType: CALENDAR_DISPLAY,
      });
    } else {
      const nextWeek = dayjs()
        .add(7, 'days')
        .toDate();
      setCookie(nextWeek);
    }
    setShouldShowCalendarModal(false);
  };

  const setCookie = (expiry) => {
    document.cookie = `${CALENDAR_DISPLAY_2025}=hidden; expires=${expiry}`;
  };

  const closeCalendarModal = useCallback(() => {
    setShouldShowCalendarModal(false);
  }, [setShouldShowCalendarModal]);

  return (
    <Modal
      closeOnOuterClick={true}
      containerClassName={styles.calendarModal}
      show={showCalendarModal}
      onClose={closeCalendarModal}
    >
      <a
        href={PRODUCT_LINK}
        rel='noreferrer'
        target='_blank'
        onClick={closeCalendarModal}
      >
        <img
          alt={ALT_TEXT}
          className={classnames(styles.calendarModalContent, styles.desktopImg)}
          loading='lazy'
          src={CALENDAR_PROMO_IMAGE}
        />
        <img
          alt={ALT_TEXT}
          className={classnames(styles.calendarModalContent, styles.mobileImg)}
          loading='lazy'
          src={CALENDAR_PROMO_IMAGE_MOBILE}
        />
        <div className={styles.calendarModalFooter}>
          <button
            className={styles.calendarModalDismiss}
            onClick={handleDismissForever}
          >
            I don&apos;t want to see this message again
          </button>
        </div>
      </a>
      <span className={styles.calendarModalCloseBtn} onClick={handleClose}>
        X
      </span>
    </Modal>
  );
};

export default observer(CalendarPromoModal);
